import Vuex from "vuex";
import Vue from "vue";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    shows: [],
    editingActiveShowId: null,
    productionEndpoint: "https://api.soundslides.org/v3",
    stageEndpoint: "",
    devEndpoint: "http://dev.soundslides.org:8000/v3",
    user: {},
    userLoaded: false,
    currentShowDetails: null,
    currentShowId: null
  },
  actions,
  getters,
  mutations
});
